import React, { useState } from 'react';
import { Rating } from 'primereact/rating';
import { Card } from 'primereact/card';

const PDVRating = () => {
  const [ratingValue, setRatingValue] = useState(null);
  const [showRating, setShowRating] = useState(false);

  const onRate = (e) => {
    setRatingValue(e.value);
  };

  const showRatingComponent = () => {
    setShowRating(true);
  };

  return (
    <div className="center-container" style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Card title="Calificación de Punto de Venta (PDV)" style={{ width: '580px' }}>
        <div className="p-grid p-justify-center">
          <div className="p-col">
            {!showRating ? (
              <div className="intro-container" onClick={showRatingComponent}>
                <p>Bienvenido al sistema de calificación de Puntos de Venta (PDV). Este sistema te permite compartir tu experiencia y opinión sobre el servicio que recibiste en un PDV específico. Haz clic aquí para comenzar:</p>
              </div>
            ) : (
              <div>
                <p>Por favor, califique su experiencia:</p>
                <Rating value={ratingValue} onChange={onRate} cancel={false} />
                {ratingValue && (
                  <div>
                    <p>¡Gracias por su calificación!</p>
                    <p>Ha calificado este PDV con {ratingValue} estrellas.</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default PDVRating;
